// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateHome from './routes/templateHome';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  templateHome,
});

// Load Events
document.addEventListener('DOMContentLoaded', () => {
  routes.loadEvents();
}, false);



// WEBPACK FOOTER //
// ./scripts/main.js